import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { INVOICE } from 'config/documents';
import InvoiceDocumentPreferences from '../../v2/InvoiceDocumentPreferences';
import { LoaderCircle } from 'lucide-react';
import { useGetDocumentTypes } from 'utils/DocumentsAPIUtils';
const { value: INVOICE_SLUG } = INVOICE;
export const ShipmentInvoiceDocumentPreferences = ({ preferences }) => {
    const { t } = useTranslation();
    const getInvoiceDocumentPreferences = () => {
        const invoicePreferences = (preferences || []).map((pref) => {
            if (pref.slug === 'invoice') {
                return Object.assign(Object.assign({}, pref), { slug: INVOICE_SLUG });
            }
            return pref;
        });
        if (!invoicePreferences.find((pref) => pref.slug === INVOICE_SLUG)) {
            const sequence = invoicePreferences.length + 1;
            return [...invoicePreferences, { slug: INVOICE_SLUG, sequence }].sort((a, b) => a.sequence - b.sequence);
        }
        return invoicePreferences.sort((a, b) => a.sequence - b.sequence);
    };
    const { data: invoiceDocumentData, isLoading } = useGetDocumentTypes({
        listType: 'invoice',
        showListType: true,
    });
    const invoiceDocumentPreferenceDocTypes = useMemo(() => (invoiceDocumentData === null || invoiceDocumentData === void 0 ? void 0 : invoiceDocumentData.getAvailableDocumentTypes) || [], [invoiceDocumentData]);
    const invoiceDocumentPreferenceDocTypesMap = useMemo(() => invoiceDocumentPreferenceDocTypes.reduce((map, pref) => (Object.assign(Object.assign({}, map), { [pref.type]: pref })), {}), [invoiceDocumentPreferenceDocTypes]);
    const renderInvoicePreferences = () => {
        return (React.createElement(Popover, { id: "invoice-preferences-popover" },
            React.createElement(InvoiceDocumentPreferences, { invoiceDocumentPreferences: getInvoiceDocumentPreferences(), invoiceDocumentPreferenceDocTypesMap: invoiceDocumentPreferenceDocTypesMap })));
    };
    if (isLoading) {
        return React.createElement(LoaderCircle, { className: "w-4 h-4 animate-spin ml-2" });
    }
    return (React.createElement("div", { className: "flex flex-1 justify-end" },
        React.createElement(OverlayTrigger, { className: "dropdown-filter-wrapper", rootClose: true, trigger: "hover", placement: "top", overlay: renderInvoicePreferences() },
            React.createElement("p", { className: "underline cursor-pointer text-blue" }, t('INVOICE_DOCUMENT_PREFERENCES')))));
};
